// extracted by mini-css-extract-plugin
module.exports = {"root":"Participants_root__CbM14","inner":"Participants_inner__3M-Ph"};